import MentionsInput from './MentionsInput';

export default MentionsInput;
